// extracted by mini-css-extract-plugin
export var accordion = "_dv-0";
export var chevron = "_dv-3";
export var closed = "_dv-2";
export var content = "_dv-4";
export var open = "_dv-1";
export var rotate = "_dv-5";